import DOMPurify from "dompurify";
import React from "react";

interface SanitizedHTMLProps extends React.HTMLAttributes<HTMLDivElement> {
  html: string;
}

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  const tag = (node.tagName || "").toLowerCase();
  if (tag !== "a") return;

  const rawTarget = node.getAttribute("target");
  const target = rawTarget ? rawTarget.trim().toLowerCase() : "";

  // Only allow exactly _blank; strip everything else (_self, _top, names, etc.)
  if (target && target !== "_blank") {
    node.removeAttribute("target");
  }

  // If opening a new tab, enforce safe rel
  if (node.getAttribute("target") === "_blank") {
    const relParts = (node.getAttribute("rel") || "")
      .split(/\s+/)
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);

    // ensure noopener and (optionally) noreferrer
    if (!relParts.includes("noopener")) relParts.push("noopener");
    if (!relParts.includes("noreferrer")) relParts.push("noreferrer");

    // write back deduped list
    node.setAttribute("rel", Array.from(new Set(relParts)).join(" "));
  }
});

export const SanitizedHTML = ({
  html,
  style,
  ...props
}: SanitizedHTMLProps) => {
  // override explicit target block https://github.com/cure53/DOMPurify/wiki/Default-TAGs-ATTRIBUTEs-allow-list-&-blocklist#html-attributes
  const santizedHTML = DOMPurify.sanitize(html, {
    ADD_ATTR: ["target"],
  });
  return (
    <div
      {...props}
      style={{ whiteSpace: "pre-wrap", ...style }}
      dangerouslySetInnerHTML={{
        __html: santizedHTML,
      }}
    />
  );
};
